const projectRoutePaths = (path: string) => [
  `/list/groups/:projectGroupId/${path}`,
  `/list/pools/:poolId/${path}`,
  `/list/share/request/:requestClientId/${path}`,
  `/list/share/offered/:offeredClientId/${path}`,
  `/list/${path}`,
];

export default projectRoutePaths;
